<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>{{ name }}</h2>
                    <ul>
                        <li><a routerLink="/">Accueil</a></li>
                        <li>{{ name }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="image" /></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="image" /></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="image" /></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="image" /></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="image" /></div>
    </div>
</div>

<section class="blog-area ptb-100">
    <div class="container">
        <div *ngIf="loading" class="text-center py-10 text-gray-500">Chargement…</div>

        <div class="row" *ngIf="!loading && publications.length">
            <div class="col-lg-4 col-md-6" *ngFor="let pub of publications">
                <div class="single-blog-post">
                    <div class="image post-cover">
                        <a [routerLink]="['/blog', smallName, pub.id]" [queryParams]="{ enterprise: pub.enterprise }">
                            <img [src]="pub.previewUrl || 'assets/img/placeholder.jpg'" alt="image" class="post-cover__img">
                        </a>
                    </div>

                    <div class="content">
                        <ul class="post-meta">
                            <li><i class="fa fa-calendar"></i> {{ pub.date | date: 'd MMMM y' }}</li>
                        </ul>

                        <h3>
                            <a [routerLink]="['/blog', smallName, pub.id]">
                                {{ pub.title }}
                            </a>
                        </h3>

                        <div [innerHTML]="pub.htmlText | slice:0:100 | breakableHtml"></div>

                        <a [routerLink]="['/blog', smallName, pub.id]" class="read-more">
                            Lire la suite
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!loading && !publications.length" class="text-center text-gray-500 py-10">
            Aucune publication trouvée.
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="image" /></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="image" /></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="image" /></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="image" /></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="image" /></div>
    </div>
</section>
